import type { ImmutableMap } from "@suse-o11y/immutable-map";
import type { ImmutableSet } from "@suse-o11y/immutable-set";
import type { ReadonlySignal, Signal } from "@suse-o11y/signal";
import { useRequiredContext } from "@suse-o11y/use-required-context";
import { type Key, createContext } from "react";

import type { TableOverflowState } from "./_overflow-state";
import type { TableColOrder } from "./col-order";

export interface TableContextValue {
	sortedBy: Signal<ImmutableSet<TableColOrder>>;
	virtualRowsState: Signal<ImmutableMap<Key, unknown>>;
	overflowState: ReadonlySignal<undefined | TableOverflowState>;
	scrollElement: null | HTMLElement;
}

const TableContext = createContext<null | TableContextValue>(null);

export const TableContextProvider = TableContext.Provider;

export const useTableContext = (): TableContextValue =>
	useRequiredContext(TableContext, {
		providerName: "TableContextProvider",
	});

export const VirtualRowContext = createContext<null | Key>(null);
